import { RoomScene } from './RoomScene';
import { GameConstants } from "../../GameConstants";
import { Button } from "../../utils/Button";
import { GameVars } from "../../GameVars";
import { AudioManager } from '../../managers/AudioManager';
import { GameManager } from '../../managers/GameManager';
import { BananaSpine } from './banana/BananaSpine';
import { Translation } from '../../Translation';

export class GameOverLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {

        super(scene);

        const background = new Phaser.GameObjects.Graphics(this.scene);
        background.fillStyle(0x000000, .9);
        background.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        background.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        background.on("pointerdown", () => {
            // 
        });
        this.add(background);

        this.addCredits();

        const backButton = new Button(this.scene, 35 * GameVars.scaleX, 35, "texture_atlas_1", "btn_close.png", "btn_close.png", true, true, .8);
        backButton.onUp(this.onClickBack, this);
        this.add(backButton);

        const midContainer = new Phaser.GameObjects.Container(this.scene);
        midContainer.setPosition(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2);
        midContainer.scaleX = GameVars.scaleX;
        this.add(midContainer);

        const titleLabel = new Phaser.GameObjects.Image(this.scene, 0, -50, "texture_atlas_1", "game_over_hilo.png");
        midContainer.add(titleLabel);

        const playButtonContainer = new Phaser.GameObjects.Container(this.scene, -85, 100);
        midContainer.add(playButtonContainer);

        const playButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_yellow.png", "btn_yellow.png", true);
        playButton.onUp(this.onClickPlay, this);
        playButtonContainer.add(playButton);

        const playButtonLabel = new Phaser.GameObjects.Text(this.scene, 0, -15, Translation.getText("PLAY_NOW"), { fontFamily: "Oswald-Medium", fontSize: "24px", color: "#622F20", align: "center" });
        playButtonLabel.setOrigin(.5);
        playButtonContainer.add(playButtonLabel);

        const roomPriceLabel = new Phaser.GameObjects.Text(this.scene, - 10, 14, GameVars.formatNumber(GameConstants.ROOM_PRICE), { fontFamily: "Oswald-Medium", fontSize: "22px", color: "#622F20", align: "center" });
        roomPriceLabel.setOrigin(.5);
        playButtonContainer.add(roomPriceLabel);

        const chipIcon = new Phaser.GameObjects.Image(this.scene, 36, 14, "texture_atlas_1", "chip_pot_icon.png");
        chipIcon.setScale(.9);
        playButtonContainer.add(chipIcon);

        const returnButtonContainer = new Phaser.GameObjects.Container(this.scene, 85, 100);
        returnButtonContainer.setScale(.9);
        midContainer.add(returnButtonContainer);

        const returnButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_blue.png", "btn_blue.png", true);
        returnButton.onUp(this.onClickBack, this);
        returnButtonContainer.add(returnButton);

        const returnButtonLabel = new Phaser.GameObjects.Text(this.scene, 0, 0, Translation.getText("RETURN_TO_GAME"), { fontFamily: "Oswald-Medium", fontSize: "24px", color: "#064150", align: "center" });
        returnButtonLabel.setOrigin(.5);
        returnButtonContainer.add(returnButtonLabel);

        const hiLoButton = new Button(this.scene, 0, 250, "texture_atlas_1", "btn_hi-lo.png", "btn_hi-lo.png", true);
        hiLoButton.onUp(this.onClickHighLow, this);
        midContainer.add(hiLoButton);

        const bananaSpine = new BananaSpine(this.scene);
        bananaSpine.setPosition(-150, -150);
        bananaSpine.setScale(.9, -.9);
        bananaSpine.setAvatarState("you-lose-start");
        midContainer.add(bananaSpine);

        if (GameVars.gameData.chips < GameConstants.ROOM_PRICE) {

            playButtonContainer.alpha = .5;
            playButton.input.enabled = false;

            this.scene.tweens.add({
                targets: hiLoButton,
                scaleX: 1.05,
                scaleY: .95,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 320,
                repeat: -1,
                yoyo: true
            });
        }

        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500
        });

        AudioManager.volumeMusic(.1);
    }

    private addCredits(): void {

        const creditsContainer = new Phaser.GameObjects.Container(this.scene, GameConstants.GAME_WIDTH / 2, 35);
        creditsContainer.setScale(GameVars.scaleX * .8, .8);
        this.add(creditsContainer);

        const w = 220;

        const creditsLabel = new Phaser.GameObjects.Text(this.scene, w / 2 - 60, -2, GameVars.formatNumber(GameVars.gameData.chips), { fontFamily: "Oswald-Medium", fontSize: "46px", color: "#ffffff" });
        creditsLabel.setOrigin(1, .5);
        creditsContainer.add(creditsLabel);

        const chipIconCreditsLabel = new Phaser.GameObjects.Image(this.scene, w / 2 - 30, 0, "texture_atlas_1", "chip_pot_icon.png");
        chipIconCreditsLabel.setScale(1.2 * GameVars.scaleX, 1.2);
        creditsContainer.add(chipIconCreditsLabel);
    }

    private onClickBack(): void {

        AudioManager.playSound("btn_click");
        RoomScene.currentInstance.removeGameOverLayer();
        RoomScene.currentInstance.showLeave();

        AudioManager.volumeMusic(.5);
    }

    private onClickPlay(): void {

        AudioManager.playSound("btn_click");
        GameManager.enterRoomScene();

        AudioManager.volumeMusic(.5);
    }

    private onClickHighLow(): void {

        AudioManager.playSound("btn_click");
        GameManager.enterHiLoScene();

        AudioManager.volumeMusic(.5);
    }
}
